__turbopack_context__.v({
  "item": "_0pMXhG_item",
  "list": "_0pMXhG_list",
  "title": "_0pMXhG_title",
});
